/* Bachelor 99 — interactive 3D book cover.
   Turns the cover like a real object: the mouse tilts it, a finger drags it,
   and it eases back on release. Everything here is transform-only, so no other
   element on the page is ever laid out again while it moves. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function book3d() {
    document.querySelectorAll('.b99 [data-b3d]').forEach(function (el) {
      if (el.dataset.b3) return;
      el.dataset.b3 = '1';
      var inner = el.querySelector('.b3d-in');
      if (!inner || reduce) return;

      var MAXY = 17, MAXX = 9;
      var tx = 0, ty = 0, cx = 0, cy = 0;        /* target and current angles */
      var raf = null, drag = false, hover = false;
      var sx = 0, sy = 0, sax = 0, say = 0;      /* where the drag started */

      function clamp(v, m) { return v < -m ? -m : (v > m ? m : v); }

      function paint() {
        cx += (tx - cx) * 0.14;
        cy += (ty - cy) * 0.14;
        inner.style.setProperty('--ry', cx.toFixed(2) + 'deg');
        inner.style.setProperty('--rx', cy.toFixed(2) + 'deg');
        el.style.setProperty('--sx', (-cx * 0.85).toFixed(1) + 'px');
        el.style.setProperty('--ss', (1 - Math.abs(cx) / 120).toFixed(3));
        el.style.setProperty('--gl', (Math.min(Math.abs(cx) / MAXY, 1) * 0.55).toFixed(3));
        el.style.setProperty('--gx', (cx * 1.9).toFixed(1) + '%');
        if (Math.abs(tx - cx) > 0.03 || Math.abs(ty - cy) > 0.03) {
          raf = requestAnimationFrame(paint);
        } else {
          cx = tx; cy = ty; raf = null;
        }
      }
      function kick() { if (!raf) raf = requestAnimationFrame(paint); }
      function rest() { tx = 0; ty = 0; kick(); }

      function follow(e) {
        var r = el.getBoundingClientRect();
        tx = clamp((e.clientX - r.left) / r.width * 2 - 1, 1) * MAXY;
        ty = clamp(1 - (e.clientY - r.top) / r.height * 2, 1) * MAXX;
        kick();
      }

      el.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        hover = true;
        el.classList.add('touched');
        follow(e);
      });

      el.addEventListener('pointermove', function (e) {
        if (drag) {
          tx = clamp((sax + (e.clientX - sx) * 0.38) / MAXY, 1) * MAXY;
          ty = clamp((say - (e.clientY - sy) * 0.22) / MAXX, 1) * MAXX;
          kick();
          return;
        }
        if (e.pointerType === 'mouse' && hover) follow(e);
      });

      el.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        hover = false;
        if (!drag) rest();
      });

      el.addEventListener('pointerdown', function (e) {
        drag = true;
        sx = e.clientX; sy = e.clientY; sax = cx; say = cy;
        el.classList.add('grabbing', 'touched');
        if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (err) {} }
      });

      function release(e) {
        if (!drag) return;
        drag = false;
        el.classList.remove('grabbing');
        if (e && e.pointerType === 'mouse' && hover) follow(e); else rest();
      }
      el.addEventListener('pointerup', release);
      el.addEventListener('pointercancel', release);
      window.addEventListener('blur', function () { release(); });

      /* one slow sway the first time it comes into view, so people notice
         that the cover can be turned */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.disconnect();
            setTimeout(function () {
              if (drag || hover) return;
              tx = MAXY * 0.6; kick();
              setTimeout(function () { if (!drag && !hover) { tx = -MAXY * 0.32; kick(); } }, 640);
              setTimeout(function () { if (!drag && !hover) rest(); }, 1280);
            }, 950);
          });
        }, { threshold: 0.35 });
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', book3d);
  } else {
    book3d();
  }
  document.addEventListener('shopify:section:load', book3d);
})();